import styled from "styled-components";
import Hamburger from "./Hamburger";

import Logo from "./Logo";
import NavItems from "./NavItems";
import Socials from "./Socials";

const StyledHeader = styled.header`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: clamp(0.9rem, 1.5vw, 1.25rem) clamp(2.2rem, 3vw, 3rem);
  min-height: 7.6rem;
  z-index: 1000; /* Stays on top of background elements like the marquee and hero images */

  @media only screen and (max-width: 750px) {
    padding: 1.35rem 2.4rem;
    min-height: 7.8rem;
  }
`;

const Side = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

const LeftSide = styled(Side)`
  justify-content: flex-start;
`;

const RightSide = styled(Side)`
  justify-content: flex-end;
  gap: 1.2rem;
`;

const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const HideMobile = styled.div`
  @media only screen and (max-width: 1200px) {
    display: none;
  }
`;

const Header = () => {
  return (
    <StyledHeader id="header-scroll">
      <LeftSide>
        <Logo />
      </LeftSide>
      
      <Center>
        <HideMobile>
          <NavItems />
        </HideMobile>
      </Center>

      <RightSide>
        <HideMobile>
          <Socials compact />
        </HideMobile>
        <Hamburger />
      </RightSide>
    </StyledHeader>
  );
};

export default Header;
